// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Hkhk","col":"Table_col__3gPr-","fulfillmentStatus":"Table_fulfillmentStatus__144mA","emailCol":"Table_emailCol__3GzRC"};